module.exports = __webpack_public_path__ + "static/media/Artboard7.c09452df.png";